import React, { useEffect, useState } from "react";

import HomeScreen from "./HomeScreen";
import HomeScreenMobile from "./HomeScreenMobile";

export default function ResponsiveHomeScreen() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <HomeScreenMobile /> : <HomeScreen />;
}